module.exports = __webpack_public_path__ + "static/media/picture10.478a6099.jpg";